<template functional>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5818_107356)">
      <rect
        x="3.75"
        y="3.75"
        width="16.5"
        height="16.5"
        rx="2.25"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 7.5H22.5"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.5 7.5H3"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 1.5L16.5 3"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 21L16.5 22.5"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 12H22.5"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.5 12H3"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 1.5L12 3"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 21L12 22.5"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 16.5H22.5"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.5 16.5H3"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 1.5L7.5 3"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5 21L7.5 22.5"
        stroke="#4A24AC"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.42774 15.5L9.93291 9.87941H11.2176L13.7308 15.5H12.3658L10.3103 10.5378H10.8242L8.76062 15.5H7.42774ZM8.68032 14.2956L9.02559 13.308H11.9162L12.2695 14.2956H8.68032ZM14.314 15.5V9.87941H15.6147V15.5H14.314Z"
        fill="#4A24AC"
      />
    </g>
    <defs>
      <clipPath id="clip0_5818_107356">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "AiIcon"
};
</script>
